/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
  this.fetchRequestOpts = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };

  this.cartDrawer = document.getElementById('cart-drawer');
  this.itemStatus = document.getElementById('cart-line-item-status');
  this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
    (total, quantityInput) => total + parseInt(quantityInput.value, 10),
    0
  );

  this.currentQuantities = [];
  this.querySelectorAll('.cart-item').forEach((item) => {
  const qtyInput = item.querySelector('.qty-input__input');
  if (!qtyInput) return;

  this.currentQuantities[item.dataset.variantId] = Number(qtyInput.value);
});

  if (this.dataset.ctCartItemsListenersBound !== 'true') {
    this.dataset.ctCartItemsListenersBound = 'true';
    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('change', this.handleChange.bind(this));
  }
}

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      this.updateQuantity(evt.target.dataset.index, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      if (Shopify.designMode) this.cartDrawer = document.getElementById('cart-drawer');

      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
const lineItemForUpdate = document.getElementById(`cart-item-${line}`);
const lineKey = lineItemForUpdate ? lineItemForUpdate.dataset.ctLineKey : '';

const changePayload = {
  quantity,
  sections: [...new Set(sections)],
  sections_url: window.location.pathname
};

if (lineKey) {
  changePayload.id = lineKey;
} else {
  changePayload.line = line;
}

this.fetchRequestOpts.body = JSON.stringify(changePayload);

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
const variantId = Number(lineItem?.dataset?.variantId || 0);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartSummary = document.getElementById('cart-summary');
          if (cartSummary) cartSummary.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);

          // Update the cart drawer quantity
          if (section.id === 'cart-icon-bubble') {
            const drawerCount = document.getElementById('cart-drawer__count');
            if (drawerCount) {
              const html = CartItems.getElementHTML(
                data.sections[section.section],
                `${section.selector} .header__cart-count-number`
              );

              drawerCount.innerHTML = `(${html})`;
            }
          }
        });

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        window.initLazyImages();
        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          lineErrors.textContent = theme.strings.cartError;
        } else {
          lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        if (input) {
          input.value = input.dataset.initialValue;
          input.closest('quantity-input').currentQty = input.dataset.initialValue;
        }
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refreshCartItems() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refreshCartDrawer(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);

          if (section.id === 'cart-items') {
            el.setAttribute('data-empty', !!el.querySelector('.js-cart-empty'));
          }
        });

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        window.initLazyImages();

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];

        // Append any quick order lists to the sections
        document.querySelectorAll('quick-order-list').forEach((quickOrderList) => {
          const closestSection = quickOrderList.closest('.shopify-section');
          if (closestSection) {
            const sectionId = closestSection.id.replace('shopify-section-', '');
            sections.push({
              id: `quick-order-list_${sectionId}`,
              section: sectionId,
              selector: `#quick-order-list_${sectionId}`
            });
          }
        });
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}
/* ================================
   CALCETUBOS - Bundle collapse
   Inicio colapsable bundle carrito
   ================================ */

if (!window.__ctBundleCollapseInit) {
  window.__ctBundleCollapseInit = true;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ct-bundle-toggle="true"]');
    if (!toggle) return;

    var bundleId = toggle.getAttribute('data-ct-bundle-id');
    if (!bundleId) return;

    var cartRoot = toggle.closest('cart-items') || document;
    var headerRow = toggle.closest('.cart-bundle-header');
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

    if (headerRow) {
      headerRow.classList.toggle('is-collapsed', isExpanded);
    }

    var bundleRows = cartRoot.querySelectorAll('[data-ct-bundle-item="true"]');

    bundleRows.forEach(function (row) {
      if (row.getAttribute('data-ct-bundle-id') === bundleId) {
        row.classList.toggle('is-bundle-collapsed', isExpanded);
      }
    });
  });
}
/* ================================
   CALCETUBOS - Bundle remove
   Inicio eliminar bundle completo
   ================================ */

if (!window.__ctBundleRemoveInit) {
  window.__ctBundleRemoveInit = true;

  var ctBundleRemoveState = {
    bundleId: null,
    button: null
  };

  function ctGetBundleModal() {
    return document.querySelector('[data-ct-bundle-modal]');
  }

  function ctCloseBundleModal() {
    var modal = ctGetBundleModal();
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('ct-bundle-modal-open');
    ctBundleRemoveState.bundleId = null;
    ctBundleRemoveState.button = null;
  }

  async function ctRemoveBundle(bundleId, triggerButton) {
    if (!bundleId) return;

    var cartRoot = triggerButton && triggerButton.closest('cart-items')
      ? triggerButton.closest('cart-items')
      : document;

    var bundleRows = cartRoot.querySelectorAll(
      '[data-ct-bundle-item="true"][data-ct-bundle-id="' + bundleId + '"]'
    );

    if (!bundleRows.length) return;

    var updates = {};
    bundleRows.forEach(function (row) {
      var lineKey = row.getAttribute('data-ct-line-key');
      if (lineKey) {
        updates[lineKey] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    if (triggerButton) {
      triggerButton.disabled = true;
    }

    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar el paquete');
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
      if (triggerButton) {
        triggerButton.disabled = false;
      }
      window.alert('No se pudo eliminar el paquete. Intenta de nuevo.');
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-ct-bundle-remove="true"]');
    if (openButton) {
      event.preventDefault();

      var modal = ctGetBundleModal();
      var bundleId = openButton.getAttribute('data-ct-bundle-id');
      if (!modal || !bundleId) return;

      ctBundleRemoveState.bundleId = bundleId;
      ctBundleRemoveState.button = openButton;

      modal.hidden = false;
      document.documentElement.classList.add('ct-bundle-modal-open');
      return;
    }

    var closeButton = event.target.closest('[data-ct-bundle-modal-close], [data-ct-bundle-modal-cancel]');
    if (closeButton) {
      event.preventDefault();
      ctCloseBundleModal();
      return;
    }

    var confirmButton = event.target.closest('[data-ct-bundle-modal-confirm]');
    if (confirmButton) {
      event.preventDefault();

      var bundleIdToRemove = ctBundleRemoveState.bundleId;
      var triggerButton = ctBundleRemoveState.button;

      ctCloseBundleModal();
      ctRemoveBundle(bundleIdToRemove, triggerButton);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      ctCloseBundleModal();
    }
  });
}